import { formatDistanceStrict } from 'date-fns'
import type { ReactNode } from 'react'
import styled from 'styled-components'

import type { Milestone } from '@/types/Activity'

import {
  parseDate,
  differenceInDays,
  rewindTo3am,
  getEarliestDate,
  getLatestDate,
} from './date'

const getStartOfQueueDay = (date?: Date) =>
  date !== undefined ? rewindTo3am(date) : undefined

export const getQueueDayZeroBeginning = (
  milestones: Milestone[] = [],
): Date | undefined =>
  getStartOfQueueDay(
    getEarliestDate(
      milestones
        .filter(milesteone => milesteone.event === 'subject.complete')
        .map(milestone => parseDate(milestone.createdAt)),
    ),
  )

export const getReopenQueueDayZeroBeginning = (
  milestones: Milestone[] = [],
): Date | undefined =>
  getStartOfQueueDay(
    getLatestDate(
      milestones
        .filter(milesteone => milesteone.event === 'subject.reopened')
        .map(milestone => parseDate(milestone.createdAt)),
    ),
  )

const Alert = styled.span`
  text-transform: uppercase;
  color: red;
  font-weight: bold;
`

export const toAgeOfReferenceLabel = (beginningOfFirstDayInQueue?: Date): ReactNode =>
  beginningOfFirstDayInQueue === undefined ? (
    <Alert>REFERENCES NOT SUPPLIED YET</Alert>
  ) : (
    <>
      {formatDistanceStrict(beginningOfFirstDayInQueue, rewindTo3am(new Date()), {
        unit: 'day',
      })}
    </>
  )

export const hasAgeOfReferenceWarning = (
  beginningOfFirstDayInQueue: Date | undefined,
  beginningOfFirstDayInReopenQueue?: Date,
): boolean =>
  beginningOfFirstDayInReopenQueue !== undefined ||
  beginningOfFirstDayInQueue === undefined
    ? false
    : differenceInDays(new Date(), beginningOfFirstDayInQueue) > 7

export const hasReopenAgeOfReferenceWarning = (
  beginningOfFirstDayInQueue: Date | undefined,
): boolean =>
  beginningOfFirstDayInQueue === undefined
    ? false
    : differenceInDays(new Date(), beginningOfFirstDayInQueue) > 7
